import {configureStore} from '@reduxjs/toolkit';
import successModalReducer from './postSuccessModal';
import searchingLocationReducer from './searchingLocation';
import nearestStoresReducer from './nearestStores';
import buyersReducer from './buyers';
import offersReducer from './offers';
import advertisementListReducer from './inputGroupAdvertisement';
import editImageProfileReducer from './editProfile';
import advertisementRegisterationReducer from './advertisementRegisteration';
import addPictureAdvertisement from './addPictureAdvertisment';
import imageCropedit from './imageCropping';
import selectedLocationReducer from './myStoreSelectedLocation';
import addPictureMyStoreReducer from './addPictureMyStore';
import registerStoreReducer from './registerStore';
import myStoreReducer from './myStore';
import saleAgentReducer from './salesAgent';
import saleAgentsLocationReducer from './saleAgentsSelectedLocation';
import setStoryReducer from './setStory';
import violationStoreReducer from './violation';
import brandReducer from './brand';
import productImageSlice from './addProductImage';
import multiStepFormReducer from './receiveCreditStore/multiStepForm.slice';

export const store = configureStore({
  reducer: {
    successModal: successModalReducer,
    searchingLocation: searchingLocationReducer,
    nearestStores: nearestStoresReducer,
    buyers: buyersReducer,
    offers: offersReducer,
    inputGroupAdvertisement: advertisementListReducer,
    editImageProfile: editImageProfileReducer,
    advertisementRegisteration: advertisementRegisterationReducer,
    addPictureAdvertisement: addPictureAdvertisement,
    imageCropedit: imageCropedit,
    myStoreSelectedLocation: selectedLocationReducer,
    addPictureMyStore: addPictureMyStoreReducer,
    registerStore: registerStoreReducer,
    myStore: myStoreReducer,
    saleAgent: saleAgentReducer,
    saleAgentsLocation: saleAgentsLocationReducer,
    setStory: setStoryReducer,
    violationStore: violationStoreReducer,
    brand: brandReducer,
    productImage: productImageSlice,
    multiStepForm: multiStepFormReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
